import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { API_URLS, API_URLS_ENTITY } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { post } from '../api/api';
import { showToast } from '../components/utils/toast';
import { IFavorite } from '../interface/favorite';
type RemoveMatterFavoriteWithParams = {
  companyId?: string;
  privatePersonId?: string;
  matterId?: string;
  successMessage: string;
  params?: Record<string, string>;
};
const removeFromFavorite = async ({
  companyId,
  privatePersonId,
  matterId,
}: RemoveMatterFavoriteWithParams): Promise<IFavorite> => {
  let basePath = '';
  let entityId = '';
  if (matterId) {
    basePath = API_URLS_ENTITY.MATTER;
    entityId = matterId;
  } else if (companyId) {
    basePath = API_URLS_ENTITY.COMPANY;
    entityId = companyId;
  } else if (privatePersonId) {
    basePath = API_URLS_ENTITY.PRIVATE_PERSON;
    entityId = privatePersonId;
  }
  return post(`${basePath}/${entityId}${API_URLS.REMOVE_FAVORITE}`);
};

export const useRemoveFromFavorite = (): UseMutationResult<
  IFavorite,
  AxiosError<{ message?: string; type?: string }>,
  RemoveMatterFavoriteWithParams
> => {
  const { setIsLoading } = useLoading();

  return useMutation({
    mutationFn: removeFromFavorite,
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: (_data, variables) => {
      showToast('success', variables.successMessage);
    },
    onError: (error) => {
      showToast('error', error.message);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
